// ─── Is an escalation still open? ────────────────────────────────────────────
//
// agent_notifications carries status ('open' | 'acknowledged' | 'resolved'),
// handled_by and handled_at, but until 2026-09-25 nothing in this CRM or the
// worker ever wrote the last two, so every escalation ever raised rendered as an
// open pill forever. The "Handled off-system" control (recruiter-agent POST
// /staff-note) resolves a thread's open escalations with handled_by = 'offline'.
//
// PURE, like the other ./lib modules, so it can be pinned without a DOM.

export const HANDLED_OFFLINE_BY = 'offline';

/** True when this escalation has been dealt with. Missing fields read as open. */
export function isEscalationHandled(n) {
  if (!n) return false;
  const s = String(n.status == null ? '' : n.status).trim().toLowerCase();
  return s === 'resolved' || s === 'acknowledged' || !!n.handled_at;
}

/** What the pill says after the reason, e.g. "handled off-system", or '' while open. */
export function escalationHandledLabel(n) {
  if (!isEscalationHandled(n)) return '';
  return n.handled_by === HANDLED_OFFLINE_BY ? 'handled off-system' : 'handled';
}

/**
 * The local patch that mirrors what /staff-note wrote, so the pills are right
 * without a reload (conversations and notifications are loaded once at app start).
 * Only OPEN escalations change -- the same set the worker resolves.
 */
export function markOpenHandledOffline(notifications, conversationId, atIso) {
  (notifications || []).forEach((n) => {
    if (n && n.conversation_id === conversationId && !isEscalationHandled(n)) {
      n.status = 'resolved';
      n.handled_by = HANDLED_OFFLINE_BY;
      n.handled_at = atIso;
    }
  });
}
